export default __webpack_public_path__ + "static/media/blue@3x.78e48abc.png";